if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.activeMediaId = null;
        this.bindLightboxDismissGuard();
        this.buildLightboxUI();
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      bindLightboxDismissGuard() {
        this.addEventListener(
          'pointerup',
          (event) => {
            if (
              event.target.closest(
                '.ssw-lightbox__nav, .product-media-modal__content, .product-media-modal__toggle, .ssw-lightbox__counter'
              )
            ) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
      }

      buildLightboxUI() {
        this.classList.add('ssw-lightbox');
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog || dialog.querySelector('.ssw-lightbox__prev')) return;

        const chevron = `<svg aria-hidden="true" focusable="false" viewBox="0 0 14 24" width="14" height="24"><path d="M1 1l11 11L1 23" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

        this.prevBtn = document.createElement('button');
        this.prevBtn.type = 'button';
        this.prevBtn.className = 'ssw-lightbox__nav ssw-lightbox__prev';
        this.prevBtn.setAttribute('aria-label', 'Previous image');
        this.prevBtn.innerHTML = chevron;

        this.nextBtn = document.createElement('button');
        this.nextBtn.type = 'button';
        this.nextBtn.className = 'ssw-lightbox__nav ssw-lightbox__next';
        this.nextBtn.setAttribute('aria-label', 'Next image');
        this.nextBtn.innerHTML = chevron;

        this.counter = document.createElement('div');
        this.counter.className = 'ssw-lightbox__counter';
        this.counter.setAttribute('aria-live', 'polite');

        dialog.append(this.prevBtn, this.nextBtn, this.counter);

        const stopDismiss = (event) => {
          event.stopPropagation();
          event.stopImmediatePropagation();
        };

        this.prevBtn.addEventListener('pointerup', stopDismiss);
        this.nextBtn.addEventListener('pointerup', stopDismiss);
        this.prevBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigate(-1);
        });
        this.nextBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigate(1);
        });
      }

      getMediaItems() {
        const container = this.querySelector('.product-media-modal__content');
        if (!container) return [];

        return [...container.children].filter((child) => child.hasAttribute('data-media-id'));
      }

      navigate(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;

        const currentIndex = items.findIndex(
          (item) => item.getAttribute('data-media-id') === this.activeMediaId
        );
        let nextIndex = currentIndex + direction;

        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;

        this.activeMediaId = items[nextIndex].getAttribute('data-media-id');
        this.showActiveMedia();
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.navigate(-1);
        }

        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.navigate(1);
        }
      }

      hide() {
        super.hide();
        this.activeMediaId = null;
      }

      show(opener) {
        super.show(opener);
        this.activeMediaId = opener.getAttribute('data-media-id');
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.activeMediaId || this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateLightboxUI();
      }

      updateLightboxUI() {
        const items = this.getMediaItems();
        const index = items.findIndex((item) => item.getAttribute('data-media-id') === this.activeMediaId);
        const hasMultiple = items.length > 1;

        if (this.counter) {
          this.counter.textContent = hasMultiple ? `${index + 1} / ${items.length}` : '';
        }

        if (this.prevBtn) this.prevBtn.hidden = !hasMultiple;
        if (this.nextBtn) this.nextBtn.hidden = !hasMultiple;
      }
    }
  );
}
